/**
 * @param {ReduxState} state - The Redux state.
 * @returns {LastRoundHighsState} The Last Round Highs state.
 */
export const lastRoundHighsSelector = state => state.statspro.lastRoundHighs;